import { GlobalDiscoveryService } from '../../app/brand/global-discovery/service';
import { useEffect, useState } from 'react';
import { ICollaboration } from '../../model/shared/ICollaboration';
import { ErrorToast } from '../../utils/toasters';

export const useCollaborations = (filter?: { username: string }) => {
    const [collaborations, setCollaborations] = useState<ICollaboration[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchCollaborations = async () => {
            try {
                setIsLoading(true);

                const response = await GlobalDiscoveryService.getCollaborationDropdown(filter);

                setCollaborations(response.data);
            } catch (error) {
                ErrorToast(error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchCollaborations();
    }, [filter]);

    return { collaborations, isLoading };
};
